import { DecisionTreeInput } from '@/components/decision-tree/components/SurveyItem/components/Question/components/DecisionTreeInput';
import { QuestionTitle } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionTitle';
import { Box, Grid, InlineAlert } from '@cmpsr/components';
import { FC } from 'react';
import { WeightAnswer, WeightProps } from './types';
import useWeightController from './Weight.controller';

export const Weight: FC<WeightProps> = ({ data, saveAnswer, defaultValue, whyWeAskModalDisclosure }) => {
  const { label, whyWeAskExplanation, pounds, ounces, id, tooltip, description, validationValues } = data;
  const {
    onInputPoundsFn,
    onInputOuncesFn,
    form,
    poundsValidationOptions,
    ouncesValidationOptions,
    onBlurPoundsFn,
    onBlurOuncesFn,
  } = useWeightController({
    id,
    validationValues,
    saveAnswer,
    defaultValue,
    pounds,
    ounces,
  });

  return (
    <Box width="full" maxWidth="450px">
      <QuestionTitle
        description={description}
        tooltip={tooltip}
        question={label}
        whyWeAskExplanation={whyWeAskExplanation}
        whyWeAskModalDisclosure={whyWeAskModalDisclosure}
      />
      <Grid gridTemplateColumns="1fr 1fr" gap="spacer-4" margin="auto" mt={6}>
        <Box>
          <DecisionTreeInput
            questionId={id}
            variant="outline"
            placeholder={pounds.placeholder}
            defaultValue={(defaultValue as WeightAnswer)?.pounds ?? undefined}
            trailingMask={pounds.trailingMask}
            borderColor={
              form.formState.errors.pounds?.message ? 'alert-error-default !important' : 'ui-element-outline-default'
            }
            {...form.register('pounds', poundsValidationOptions)}
            onInput={onInputPoundsFn}
            onBlur={onBlurPoundsFn}
            autoFocus
          />
          {form.formState.errors.pounds?.message ? (
            <InlineAlert status="error" my="spacer-2" alignItems="flex-start">
              <InlineAlert.Icon />
              <InlineAlert.Message>{form.formState.errors.pounds?.message}</InlineAlert.Message>
            </InlineAlert>
          ) : null}
        </Box>
        <Box>
          <DecisionTreeInput
            questionId={id}
            variant="outline"
            placeholder={ounces.placeholder}
            defaultValue={(defaultValue as WeightAnswer)?.ounces ?? undefined}
            trailingMask={ounces.trailingMask}
            borderColor={
              form.formState.errors.ounces?.message ? 'alert-error-default !important' : 'ui-element-outline-default'
            }
            {...form.register('ounces', ouncesValidationOptions)}
            onInput={onInputOuncesFn}
            onBlur={onBlurOuncesFn}
          />
          {form.formState.errors.ounces?.message ? (
            <InlineAlert status="error" my="spacer-2" alignItems="flex-start">
              <InlineAlert.Icon />
              <InlineAlert.Message>{form.formState.errors.ounces?.message}</InlineAlert.Message>
            </InlineAlert>
          ) : null}
        </Box>
      </Grid>
    </Box>
  );
};
